import axios from 'axios';
import { JwtHelper } from '@/tools/jwt.ts';
import { AxiosResponse, AxiosError } from 'axios';

let url: string = '';
let headers: any = {
  'Content-type': 'application/json',
  Accept: 'application/json'
};

export const request = async (method: any, customUrl?: string, data?: any, encrypt?: boolean) => {

  if (encrypt === true) {
    const signRequest = new JwtHelper();

    await signRequest.signRequest(data).then((response) => {
      headers.Authorization = `Bearer ${response}`;
    });

    if (customUrl) url = customUrl;
    
    return axios({
      method: method,
      url: url,
      headers: headers,
    })
  }

  if (customUrl) url = customUrl;

  return axios({
    method: method,
    url: url,
    data: data,
    headers: headers
  })
};